import * as api from "@/api/subProject";
import { useQuery } from "react-query";

export function useGetSubProjectsByProject(projectId?: string) {
  const queryKey = ["subprojects", projectId];
  return useQuery(queryKey, () => api.getSubProjectsByProject(projectId), {
    enabled: Boolean(projectId),
  });
}
